import { JSX, ReactNode } from 'react';
import Label from '../Label/Label';
import { withStyles } from '../../../utils/utils';
import styles from './ElementContainer.module.scss';

export type ElementContainerProps = {
  label: ReactNode | null;
  height?: string;
  width?: string;
  tooltip?: JSX.Element;
  required?: boolean;
  isBold?: boolean;
  hasNoPadding?: boolean;
  padding?: string;
  color?: 'black' | 'dark-grey' | 'grey' | 'red';
  input: JSX.Element;
  optionalSignifier?: string;
  helpText?: string;
  htmlFor?: string;
  justifyContent?: string;
  isInactive?: boolean;
  containerClassName?: string;
};

const ElementContainer = (props: ElementContainerProps) => {
  const {
    label,
    height,
    width,
    tooltip,
    required = false,
    isBold = true,
    hasNoPadding,
    padding = '20px 0 6px',
    input,
    optionalSignifier,
    color,
    helpText,
    htmlFor,
    justifyContent,
    isInactive = false,
    containerClassName,
  } = props;

  const classes = withStyles(styles);

  return (
    <div
      className={classes('elementContainer', isInactive && 'inactive', containerClassName)}
      style={{ height, width, justifyContent }}
    >
      {label && (
        <div className={styles.labelContainer}>
          <Label
            htmlFor={htmlFor}
            label={label}
            required={required}
            isBold={isBold}
            color={color}
            hasNoPadding={hasNoPadding}
            padding={padding}
            optionalSignifier={optionalSignifier}
          />
          {tooltip}
        </div>
      )}
      <div>{input}</div>
      {helpText && <div className={styles.helpTextContainer}>{helpText}</div>}
    </div>
  );
};

export default ElementContainer;
